<template>
  <div
    v-for="(actionResultMessage, actionResultMessageIndex) in actionResultMessages"
    :key="actionResultMessage.id"
    class="action-result-message"
    :class="{ 'fade-out': actionResultMessage.fadeOut }"
    :style="{
      top: `${(actionResultMessageIndex * ACTION_RESULT_MESSAGE_HEIGHT_PIXELS) + ((actionResultMessageIndex + 1) * ACTION_RESULT_MESSAGE_VERTICAL_MARGIN_PIXELS)}px`,
      height: `${ACTION_RESULT_MESSAGE_HEIGHT_PIXELS}px`,
      'line-height': `${ACTION_RESULT_MESSAGE_HEIGHT_PIXELS}px`,
      ...actionResultMessage.colors
    }"
  >
    {{ actionResultMessage.message }}
    <button
      type="button"
      title="Dismiss"
      class="dismiss-button"
      @click="removeActionResultMessage(actionResultMessage.id)"
    >&times;</button>
  </div>
</template>

<script lang="ts" setup>
  import { useActionResultMessages } from '@/composables/useActionResultMessages';

  const { actionResultMessages, removeActionResultMessage } = useActionResultMessages();
  const ACTION_RESULT_MESSAGE_HEIGHT_PIXELS = 40;
  const ACTION_RESULT_MESSAGE_VERTICAL_MARGIN_PIXELS = 12;
</script>

<style scoped>
  .action-result-message {
    display: inline-block;
    position: fixed;
    left: 0px;
    right: 0px;
    margin: 0px auto;
    z-index: 1500;
    font-size: 14px;
    font-weight: 700;
    padding: 0px 46px 0px 12px;
    width: 760px;
    max-width: calc(100% - 24px);
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    transition: opacity 1s ease-out, top 400ms linear;
    border-width: 1px solid #c3e6cb;
    border-radius: 4px;
    background-color: #d4edda;
    color: #155724;
    text-align: left;
  }

  .action-result-message.fade-out {
    opacity: 0;
  }

  .action-result-message .dismiss-button {
    padding: 0px 10px;
    width: 34px;
    opacity: 0.5;
    background-color: transparent;
    border: none;
    position: absolute;
    top: 0px;
    right: 0px;
    bottom: 0px;
    font-size: 24px;
    font-weight: 700;
    color: inherit;
  }

  .action-result-message .dismiss-button:hover,
  .action-result-message .dismiss-button:active,
  .action-result-message .dismiss-button:focus {
    opacity: 0.75;
  }
</style>
